import { render, staticRenderFns } from "./filesAttach.vue?vue&type=template&id=608665f7&scoped=true"
import script from "./filesAttach.vue?vue&type=script&lang=js"
export * from "./filesAttach.vue?vue&type=script&lang=js"
import style0 from "./filesAttach.vue?vue&type=style&index=0&id=608665f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608665f7",
  null
  
)

export default component.exports